import { render, staticRenderFns } from "./UserLoginCodeChangeActivationType.vue?vue&type=template&id=faa286fe&"
import script from "./UserLoginCodeChangeActivationType.vue?vue&type=script&lang=js&"
export * from "./UserLoginCodeChangeActivationType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports